import Vue from 'vue'
import feather from 'vue-icon'
Vue.config.productionTip = false
Vue.use(feather, 'v-feather-icon')
export { default as Chat } from './components/Chat.vue';
